import ACloseIcon from './a-close-icon';

export default ACloseIcon;